import { showError } from '@/commons/globalMessage';
import ColumnCommon from '@/commons/wildcards/constants/ColumnCommon';
import ErrorCode from '@/commons/wildcards/constants/ErrorCode';
export class BaseStore {
  constructor(api) {
    const me = this;
    me.state = {
      items: [],
      loading: false,
      payload: null,
      total: 0,
      totalAll: 0,
      summary: null,
      // Kết quả của hàm loadSummaryloadSummary
      // mặc dù ở hàm loadSummary, summary đã gán bằng kết quả nhưng sau đó đã được set lại
      summaryRes: null,
      _config: {},
      layout: [],
    };

    me.action = {
      /**
       * Lấy đường dẫn controller api
       */
      getController() {
        return api.getAPIUrl();
      },

      /**
       * Load dữ liệu
       * @param {Object} payload thông tin query
       */
      async load(payload) {
        const me = this;
        let res = null;
        try {
          me.loading = true;
          res = await api.getList(payload || {});
          this.setPaging(res);
        } finally {
          me.loading = false;
        }
        return res;
      },

      /**
       * Load dữ liệu gọi api
       * @param {*} payload
       * @returns
       */
      async loadDataFromApi(payload) {
        const me = this;
        let res = null;

        try {
          me.loading = true;
          res = await api.getList(payload || {});
        } finally {
          me.loading = false;
        }

        return res;
      },
      /**
       * Load dữ liệu để thêm/sửa/nhân bản
       * Hàm này sẽ không commit mà return value để binding cho form
       */
      async get(payload) {
        const method = 'get' + payload.action;
        delete payload.action;
        const res = await api[method](payload);
        return res;
      },
      /**
       * load dữ liệu dòng tổng
       * @param {Object} payload Thông tin query
       * @return dữ liệu từ server
       */
      async loadSummary(payload) {
        let res = null;
        try {
          res = await api.getListSummary(payload || {});
          this.summary = res;
          this.summaryRes = res;
        } finally {
          if (res) {
            this.setPaging(res);

            // NVTUYEN 09.06.2023 thực hiện sửa lại cho đúng thám số đầu vào
            this.setPayload(payload);
          }
        }
        return res;
      },

      /**
       * Load dữ liệu tree (lấy full theo filter)
       * @param {*} payload
       */
      async loadTree(payload) {
        const me = this;
        try {
          me.loading = true;
          const res = await api.getTree(payload || {});
          if (Array.isArray(res)) {
            me.items = res;
          }
        } finally {
          me.loading = false;
        }
      },
      /**
       * Lấy bản ghi theo id
       */
      async getDataByIds(payload) {
        return await api.getDataByIds(payload || {});
      },
      /**
       * Lấy full dữ liệu danh mục
       */
      async getFullList(payload) {
        const me = this;
        let res = [];
        try {
          this.loading = true;
          res = await api.getFullList(payload || {});
        } finally {
          this.loading = false;
        }
        return res;
      },
      /**
       * Insert dữ liệu
       * @param {*} payload
       * @returns
       */
      async insert(payload) {
        const me = this;
        const res = await api.insert(payload);
        if (res) {
          if (Array.isArray(res)) {
            me.items = [...res, ...me.items];
          } else {
            me.items = [res, ...me.items];
          }
        }
        return res;
      },
      /**
       * Insert nhiều dữ liệu
       * @param {*} payload
       * @returns
       * VDDONG 13/10/2023
       */
      async insertPatch(payload) {
        const me = this;
        const res = await api.insertMulti(payload);
        if (res) {
          if (Array.isArray(res)) {
            me.items = [...res, ...me.items];
          } else {
            me.items = [res, ...me.items];
          }
        }
        return res;
      },
      /**
       * Update dữ liệu
       * @param {*} payload
       */
      async update(payload) {
        const res = await api.update(payload);
        this.updateItem(res);
        return res;
      },

      /**
       * Xóa dữ liệu
       * @param {X} payload
       */
      async delete(payload) {
        const res = await api.delete(payload);
        this.deleteItems(payload, res);
        return res;
      },

      /**
       * Check dữ liệu
       */
      async deleteArise(payload) {
        const res = await api.deleteArise(payload);
        return res;
      },
      setPaging(data) {
        if (data) {
          for (const i in data) {
            const resultValue = data[i];
            switch (i) {
              case 'Data':
                this.items = resultValue;
                break;
              case 'Total':
                this.total = resultValue;

                //  hkcuong1 10/06/2026: Xử lý lỗi khi select 1 cái 
                //  rồi tìm cái khác sau đó select thì nó đang lấy tổng theo cái kết quả mới tìm
                if (resultValue > (this.totalAll || 0)) {
                  this.totalAll = resultValue;
                }
                break;
              case 'SummaryData': {
                this.summary = resultValue;
                break;
              }
            }
          }
        }
      },

      setPayload(payload) {
        this.payload = payload;
      },

      /**
       * Cập nhật ngược vào list
       * @param {Object} item
       */
      updateItem(data) {
        const keyField = this._config.key;
        if (keyField) {
          const id = data[keyField];
          for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];

            if (item[keyField] === id) {
              // Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
              // NCPHUOC 08/07/2022
              // NCPHUOC 02.06.2023 thay check item.hasOwnProperty(ColumnCommon.parentId) -> this._config?.isTree cho trường hợp dạng Tree
              if (this._config?.isTree && item[ColumnCommon.parentId] !== data[ColumnCommon.parentId]) {
                // check nếu res data không có prop parent_id thì gán thêm nó vào data
                // PCKIEN 02.06.2023
                !data.hasOwnProperty(ColumnCommon.parentId) ? (data.parent_id = '') : null;

                Object.assign(item, data);
                this.items = [...this.items];
              } else {
                Object.assign(item, data);
              }
              break;
            }
          }
        }
      },

      /**
       * Cập nhật ngược vào list khi xóa
       * @param {*} res
       * @returns
       */
      deleteItems(payload, res) {
        const models = this.getModelDelete(payload);
        const errorCodes = Object.values(ErrorCode);
        const key = this._config.key;

        const mapDeleteError = {};

        if (Array.isArray(res)) {
          res.forEach(item => {
            if (errorCodes.some(y => y === item.Code)) {
              const itemError = models[item.Index];
              mapDeleteError[itemError[key]] = true;
              return true;
            }
          });
        }

        const removeItems = models.filter(x => !mapDeleteError.hasOwnProperty(x[key]));

        if (removeItems.some(x => x)) {
          this.items = this.items.filter(x => !removeItems.some(y => y[key] === x[key]));
        }
        return removeItems;
      },
      getModelDelete(payload) {
        return payload.map(x => x.Entity);
      },
      updateActiveRow(item) {},

      /**
       * Lấy các chứng từ tham chiếu
       */
      async loadVoucherReference(payload) {
        const res = await api.loadVoucherReference(payload || {});

        return res;
      },

      /**
       * Kiểm tra chứng từ đã có chứng từ hạch toán đồng thời chưa
       * dmanh 24.10.2025
       */
      async checkExistParallelVoucher(payload) {
        const res = await api.checkExistParallelVoucher(payload);
        return res;
      },

      /**
       * Lấy các chứng từ tham chiếu của nhiều chứng từ
       * nvthinh 05.10.2023
       */
      async loadMultipleVoucherReference(payload) {
        const res = await api.loadMultipleVoucherReference(payload || []);
        return res;
      },

      /**
       * Lưu các chứng từ tham chiếu
       * HQMINH 14.06.2023
       */
      async saveVoucherReference(payload) {
        const res = await api.saveVoucherReference(payload || {});

        return res;
      },

      /**
       * kiểm tra chứng từ có phải tạo từ kho bạc điện tử
       * ntduong2 25.12.2023
       */
      async checkCreateByDvc(payload) {
        const res = await api.checkCreateByDvc(payload);
        return res;
      },

      /**
       * Lấy dữ liệu chi tiết chứng từ từ master
       * HQMINH 15.04.2024
       *
       */
      async getListDetail(payload) {
        let res = await api.getListDetail(payload);
        return res;
      },
    };
  }
}
